import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { post } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionRealTimeInventoryApiV2Parameter, GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

const realTimeInventoryUrl = "/api/v1/realtimeinventory";

export function customGetProductCollectionRealTimeInventory(parameter: GetProductCollectionRealTimeInventoryApiV2Parameter) {
    let url = realTimeInventoryUrl;
    if (parameter.expand) {
        url += `?expand=${parameter.expand.join(",")}`;
    }

    if (parameter.additionalQueryStringParameters) {
        const qp = new URLSearchParams(parameter.additionalQueryStringParameters).toString();
        url += parameter.expand? `&${qp}` : `?${qp}`;
    }

    return post<GetProductCollectionRealTimeInventoryApiV2Parameter, RealTimeInventoryModel>(`${url}`, {
        productIds: parameter.productIds,
        configurations: parameter.configurations,
    });
}

export function getSelectedWarehouse(state: ApplicationState): string | undefined {
    return (state as any)?.cpeState?.warehouseData?.selectedWarehouseForInventory;
}